import Logo from '../../../primitives/Logo';
import { type ErrorPageStrings } from '../strings';

export function ErrorContent({
  repubPath,
  resourcesUrl,
  statusLogoPng,
  strings,
}: {
  repubPath: string;
  resourcesUrl: string;
  statusLogoPng: string;
  strings: ErrorPageStrings;
}) {
  return (
    <>
      <div className="textSection" data-testid="errorContent">
        <img
          alt={strings.internalServerError}
          className="mobileImage"
          data-testid="mobileErrorImage"
          src={`${resourcesUrl}/assets/img/${statusLogoPng}`}
        />
        <Logo resourcesUrl={resourcesUrl} />
        <div className="oops">{strings.header}!</div>
        <p className="text">{strings.description}.</p>
        <a className="homepage" href={repubPath || '/'}>
          {strings.mainCta}
        </a>
        <p className="text">{strings.supportText}?</p>
        <div className="buttonSection">
          <a href={`${repubPath}/${strings.freeBetsCtaUrl}`}>{strings.freeBetsCtaText}</a>
          <a href={`${repubPath}/${strings.picksCtaUrl}`}>{strings.picksCtaText}</a>
          <a href={`${repubPath}/${strings.bettingGuidesCtaUrl}`}>{strings.bettingGuidesCtaText}</a>
        </div>
      </div>
      <img
        alt={strings.internalServerError}
        className="desktopImage"
        data-testid="desktopErrorImage"
        src={`${resourcesUrl}/assets/img/${statusLogoPng}`}
      />
    </>
  );
}
